<template>
  <div>
    <!-- 1  -->
    <!-- [MATCH-READ-C-POP] 받은 신청서 보기(기업) -->
    <!-- [MATCH-READ-P-POP] 받은 신청서 보기(개인) -->
    <DirectMatchReadPopup :isModal="modalPopup.matchReadPopup" />

    <!-- 3 -->
    <!-- [MATCH-ACCEPT-C-POP] 승인서 작성(기업) -->
    <!-- [MATCH-ACCEPT-P-POP] 승인서 작성(개인) -->
    <DirectMatchAcceptPopup :isModal="modalPopup.matchAcceptPopup" />

    <!-- 5 -->
    <!-- [MATCH-DENY-C-POP] 거절서 작성(기업) -->
    <!-- [MATCH-DENY-P-POP] 거절서 작성(개인) -->
    <DirectMatchDenyPopup :isModal="modalPopup.matchDenyPopup" />

    <!-- 7 -->
    <!-- [RECEIVE-ACCEPT-POP] 보낸 신청서 보기(승인) -->
    <DirectReceiveAcceptPopup :isModal="modalPopup.receiveAcceptPopup" />
    <!-- [RECEIVE-DENY-POP] 보낸 신청서 보기(거절) -->
    <DirectReceiveDenyPopup :isModal="modalPopup.receiveDenyPopup" />

    <DirectDeletePopup
      :isModal="modalPopup.deletePopup"
      @removeItem="$emit('removeItem')"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import DirectDeletePopup from "@/components/matching/popup/direct/DirectDeletePopup.vue";
import DirectMatchDenyPopup from "@/components/matching/popup/direct/DirectMatchDenyPopup.vue";
import DirectMatchAcceptPopup from "@/components/matching/popup/direct/DirectMatchAcceptPopup.vue";
import DirectReceiveAcceptPopup from "@/components/matching/popup/direct/DirectReceiveAcceptPopup.vue";
import DirectReceiveDenyPopup from "@/components/matching/popup/direct/DirectReceiveDenyPopup.vue";
import DirectMatchReadPopup from "@/components/matching/popup/direct/DirectMatchReadPopup.vue";

export default {
  components: {
    DirectDeletePopup,
    DirectMatchDenyPopup,
    DirectMatchAcceptPopup,
    DirectReceiveAcceptPopup,
    DirectReceiveDenyPopup,
    DirectMatchReadPopup,
  },
  name: "MatchingReceivePopups",
  computed: {
    ...mapState("directMatching", ["modalPopup"]),
  },
};
</script>
